import React from "react";

import SideBar from "../../Layout/Sidebar/SideBar";
import HeaderTop from "../../Layout/HeaderTop";
import { useRef, useState, useEffect, useContext } from "react";
//import AuthContext from '../context/AuthProvider';
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import axios from "../../api/axios";
import Swal from "sweetalert2";
import UnitMasterDDL from "../DropdownList/UnitMasterDDL";
import SideMenu from "../../Layout/SideMenu";
//import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Layout, Space } from "antd";
import FooterBottom from "../../Layout/FooterBottom";
import dayjs from "dayjs";
import { DatePicker } from "antd";

export const PaidHolidayMaster = (props) => {
  const { Header, Footer, Sider, Content } = Layout;
  const headerStyle: React.CSSProperties = {
    textAlign: "center",
    height: 64,
    paddingInline: 50,
    lineHeight: "64px",
    backgroundColor: "#ffff",
  };

  const contentStyle: React.CSSProperties = {
    float: "left",
  };

  const siderStyle: React.CSSProperties = {
    backgroundColor: "#ffff",
  };

  const footerStyle: React.CSSProperties = {
    backgroundColor: "#ffff",
  };
  const INSERTPaidHoliday_URL = "/InsertPaidHolidayDetails";
  const UPDATEPaidHoliday_URL = "/UpdatePaidHolidayDetails";
  const PaidHolidayDETAIL_URL = "/GetPaidHolidayFromPaidHolidayId";
  const userRef = useRef();
  const errRef = useRef();
  const navigate = useNavigate();
  const UnitMasterDDLRef = useRef();

  const [PaidHolidayId, setPaidHolidayId] = useState(0);
  const [UnitId, setUnitId] = useState(0);

  const [UnitName, setUnitName] = useState("");
  const [PaidHolidayName, setPaidHolidayName] = useState("");
  let newDateTime = new Date().toLocaleTimeString();
  //const [PaidHolidayDate, setPaidHolidayDate] = useState(newDateTime);
  const [PaidHolidayDate, setPaidHolidayDate] = useState(new Date());
  const [IsActive, setIsActive] = useState(false);
  const [CompanyId, setCompanyId] = useState("");
  const [MSG, setErrMsg] = useState("");
  const [sucecess, setSucecess] = useState(false);
  const [btnLabel, setbtnLabel] = useState(false);

  const { state } = useLocation(0);

  const handleChange = (event) => {
    if (event.target.checked) {
      console.log("✅ Checkbox is checked");
      setIsActive(true);
    } else {
      console.log("⛔️ Checkbox is NOT checked");
      setIsActive(false);
    }

    console.log(IsActive);
  };

  const setIsActiveValue = (value) => {
    setIsActive((pre) => (pre = value));
  };

  useEffect(() => {
    setPaidHolidayId(state.id);
    if (state.id == 0) {
      //alert('New');
      setPaidHolidayName("");
      setIsActive(false);
      setbtnLabel("Save");
    } else {
      // alert(state.id);
      const FetchPaidHolidayDetails = async () => {
        const response = await axios.get(
          PaidHolidayDETAIL_URL + "?PaidHolidayId=" + state.id
        );

        setPaidHolidayName(response.data.paidHolidayName);
        setPaidHolidayDate(response.data.paidHolidayDate);
        setPaidHolidayId(response.data.PaidHolidayId);
        setUnitName(response.data.unitName);
        setUnitId(response.data.unitId);
        console.log(UnitId);
        console.log(response.data.status);
        if (response.data.status == "true") {
          console.log("set True");
          setIsActiveValue(true);
          console.log(IsActive);
        } else {
          console.log("set False");

          // setIsActive(false);
          setIsActiveValue(false);
          console.log(IsActive);
        }
      };
      FetchPaidHolidayDetails();
      setbtnLabel("Update");
    }

    userRef.current.focus();
  }, []);

  // useEffect(() => {

  //   setErrMsg('');
  //   //UserList.apply();

  // }, [ , userName, Password ])

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      //          alert(userId);

      //    console.log(userId);
      if (PaidHolidayId == 0) {
        console.warn(localStorage.getItem("companyId"));
        setUnitId(UnitMasterDDLRef.current.getUnitId());
        console.log(UnitMasterDDLRef.current.getUnitId());
        console.log(UnitId);
        const response = await axios.post(
          INSERTPaidHoliday_URL,
          JSON.stringify({
            PaidHolidayName: PaidHolidayName,
            PaidHolidayDate: PaidHolidayDate,
            UnitId: UnitMasterDDLRef.current.getUnitId(),
            IsActive: IsActive,
            CompanyId: localStorage.getItem("companyId"),
          }),
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
            withCredentials: true,
          }
        );
        console.log(response.data);
        setErrMsg(response.data);
        setPaidHolidayName("");
        setUnitId(0);
        setIsActive(false);

        //setCompanyId('');
        // UserList
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: response.data,
          showConfirmButton: false,
          timer: 1500,
        });

        // alert('Saved successfully.')
        navigate("/PaidHoliday");
      } else {
        setUnitId(UnitMasterDDLRef.current.getUnitId());
        console.log(UnitMasterDDLRef.current.getUnitId());
        console.log(UnitId);
        const response = await axios.post(
          UPDATEPaidHoliday_URL,
          JSON.stringify({
            PaidHolidayId: PaidHolidayId,
            PaidHolidayName: PaidHolidayName,
            PaidHolidayDate: PaidHolidayDate,
            UnitId: UnitId,
            IsActive: IsActive,
            CompanyId: localStorage.getItem("companyId"),
          }),
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
            withCredentials: true,
          }
        );
        console.log(response.data);
        setErrMsg(response.data);
        setPaidHolidayName("");
        setPaidHolidayId(0);
        setIsActive(false);
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: response.data,
          showConfirmButton: false,
          timer: 1500,
        });
        navigate("/PaidHoliday");
      }
    } catch (error) {
      console.log("error", error);
    }
    e.preventDefault();
  };

  return (
    <>
      <div className="layoutContainer screenCenter">
        <div className="loginContainer">
          <form onSubmit={handleSubmit}>
            <h2>PaidHoliday Master</h2>
            <input
              type="Text"
              className="form-controll"
              id="PaidHolidayName"
              onChange={(e) => setPaidHolidayName(e.target.value)}
              ref={userRef}
              autoComplete="off"
              value={PaidHolidayName}
              placeholder="PaidHoliday Name"
              required
            ></input>
            {/* <input
                    type="Date"
                    className="form-controll"
                    id="PaidHolidayDate"
                    onChange={(e) => setPaidHolidayDate(e.target.value)}
                    ref={userRef}
                    autoComplete="off"
                    value={PaidHolidayDate}
                    placeholder="dd-mm-yyyy"
                    required
                  ></input> */}

            <DatePicker
              className="form-controll"
              format="DD-MMM-YYYY"
              onChange={(date) => setPaidHolidayDate(date)}
              value={dayjs(PaidHolidayDate)}
            />

            {/* <input type="Text" className="form-controll" id="PaidHolidayDate" onChange={(e) => setPaidHolidayDate(e.target.value)}
                            ref={userRef} autoComplete="off" value={PaidHolidayDate} placeholder="PaidHolidayDate" required></input> */}
            {/* <select value={PaidHolidayDate} onChange={(e) => setPaidHolidayDate(e.target.value)} >
  <option value="IN">IN</option>
  <option value="OUT">OUT</option>  
</select>            */}
            <UnitMasterDDL
              ref={UnitMasterDDLRef}
              unitId={UnitId}
            ></UnitMasterDDL>
            <label className="form-controll" htmlFor="IsActive">
              Is Active
            </label>{" "}
            &nbsp;
            <input
              type="CheckBox"
              id="IsActive"
              checked={IsActive}
              onChange={(e) => setIsActive(e.target.checked)}
            ></input>
            {/* 
<input type="RetypePassword" className="form-controll" id="RetypePassword" onChange={(e) => setPassword(e.target.value)}
              autoComplete="off" value={Password} placeholder="Retype Password" required></input> */}
            <button className="btn btn-primary"> {btnLabel}</button>
            <div>
              <label>{MSG}</label>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
